import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import indsac_transport from "../Images/indsac-transport.gif";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  

export default function Transport() {
  return (
    <>
      <SEO  //
        title="AI ERP & CRM for Transport & Logistics Industry | EnteliPro"
        description="EnteliPro offers AI-powered ERP and CRM solutions for transport and logistics companies. Manage fleets, shipments, routes, and customer relationships with intelligent automation."
        keywords="Transport ERP Software, AI CRM for Logistics, Fleet Management Software, Supply Chain Logistics, Route Optimization, Transportation Management"
        canonical="https://www.entelipro.com/Transport"
        ogImage="https://www.entelipro.com/static/media/indsac-transport.gif"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">  
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Transport Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsac_transport}
                  alt="EnteliPro AI ERP for Transport and Logistics Industry"  // 
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}> 
                  AI ERP & CRM for Transport & Logistics Industry
                </h1>
                <p className="para">
                  The transport industry is one of the largest types of business
                  industries. EnteliPro delivers intelligent ERP solutions tailored
                  for transport and logistics companies.
                </p>
                <div className="jst-two-coloums">
                  <div className="icon-text">
                    <p className="para">
                      This industry deals with the movement of humans, things,
                      and animals by various modes of transportation.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      The main modes of transportation are air, land (Road and
                      Rail), and water. The transportation industry makes up the
                      largest part of any country's economy.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies transport-tight-top">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>AI ERP & CRM Solution for Transport Industry</h3>
              <p className="para">
                Transporting management software is a necessity, because of the
                continuously growing demand, and thus, a growing number of
                customers. Such industry as travel and transportation implies a
                variety of transfer services that should always be fast, safe,
                and simple.
              </p>
              <br />
              <p className="para">
                We are providing CRM solutions for global transportation
                services and travel agencies. No matter what kind of services
                you provide, we develop CRM that would make your company reach
                new heights.
              </p>
            </div>
            <br /> <br />
            <div className="text-center">
              <h3>We Provide You</h3>
            </div>
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Centralize Customer Information</h4>
                  <p className="para">
                    Transportation enables the company to centralize and share
                    the information it has about customers. Your sales
                    representatives will have a complete view of their
                    contacts.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Monitor Business Activity</h4>
                  <p className="para">
                    With our CRM for transportation, integrated reporting tools
                    (dashboards, etc.), managers can monitor the activity of
                    their teams.
                  </p>
                  <br />
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Boost Sales Productivity</h4>
                  <p className="para">
                    {`${project_name}`} solution for transportation, your sales
                    team can avoid wasting time on repetitive tasks and focus
                    instead on high value-added tasks.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies transport-tight-top">
        <div className="recent-work ">
          <div className="container">
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Automated Information Updating</h4>
                  <p className="para">
                    CRM helps benefit business profitability by focusing on
                    timely updating customer information and fast order
                    processing. It also allows organizing efficient shipping and
                    delivery of goods.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Ensuring Safety of Shipments</h4>
                  <p className="para">
                    A customized CRM system can have integrated with electronic
                    databases to provide information about the current status
                    and location of goods and materials.
                  </p>
                  <br />
                  <br />
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Manage Customer Complaints</h4>
                  <p className="para">
                    In the transportation sector, customer complaints are a
                    sensitive issue. CRM following up on customer complaints and
                    processing them is fast and consistent.
                  </p>
                  <br />
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}